import React from 'react';
import styled from 'styled-components';
// components
import PortalContainer from '../portal/portal-container';
import { useSelector } from 'react-redux';

const Toolbar = ({ className }) => {
  const pathname = useSelector((state) => state.router.location.pathname);
  if (pathname.includes('new')) return <></>;
  return (
    <div className={className}>
      <PortalContainer />
    </div>
  );
};

export default styled(Toolbar)`
  display: flex;
  flex-shrink: 0;
  align-items: center;
  gap: 16px;
  padding: 0px 8px;
  background-color: white;
  height: 74px;
  border-bottom: 1px solid var(--grey200);
`;
